import { useEffect } from "react";
import { useShallow } from "zustand/react/shallow";
import { toast } from "sonner";
import { useClinicalEvaluationStore } from "../../store/useClinicalEvaluationStore";

const AppraisalGrading = ({ goToNextTab }) => {
  const selectedAppraisalTables = useClinicalEvaluationStore(
    useShallow((state) => state.selectedAppraisalTables),
  );
  const setSelectedAppraisalTables = useClinicalEvaluationStore(
    (state) => state.setSelectedAppraisalTables,
  );

  useEffect(() => {
    // Normalize persisted legacy states so at least one method is active by default.
    if (!selectedAppraisalTables?.f1 && !selectedAppraisalTables?.f2) {
      setSelectedAppraisalTables({ f1: true, f2: false });
    }
  }, [selectedAppraisalTables, setSelectedAppraisalTables]);

  const setAppraisalFlag = (key, checked) => {
    const next = { ...selectedAppraisalTables, [key]: checked };
    if (!next.f1 && !next.f2) {
      toast.error("At least one grading table must stay selected.");
      return;
    }
    setSelectedAppraisalTables(next);
  };

  return (
    <div className="flex h-full flex-col">
      <div className="flex h-[50vh] h-[calc(100vh-180px)] w-full flex-col p-4">
        <div className="mb-4 flex gap-8">
          <label className="label">
            <span className="label-text font-semibold">
              Grading System for suitability:
            </span>
          </label>
          <label className="flex items-center gap-2">
            <input
              type="checkbox"
              className="checkbox"
              checked={selectedAppraisalTables.f1}
              onChange={(event) => {
                setAppraisalFlag("f1", event.target.checked);
              }}
            />
            <span>F1</span>
          </label>
          <label className="flex items-center gap-2">
            <input
              type="checkbox"
              className="checkbox"
              checked={selectedAppraisalTables.f2}
              onChange={(event) => {
                setAppraisalFlag("f2", event.target.checked);
              }}
            />
            <span>F2</span>
          </label>
          <div className="flex w-full justify-end">
            <button
              className="btn btn-primary tooltip tooltip-left"
              data-tip="Click to proceed"
              onClick={goToNextTab}
            >
              Next
            </button>
          </div>
        </div>
        <div className="mt-8 flex w-full">
          <div className="flex w-1/2 items-center justify-center">
            <img
              src="/F1_Clinical_Method.png"
              alt="Appraisal Image 1"
              className="max-h-full object-contain"
            />
          </div>
          <div className="flex w-1/2 items-center justify-center">
            <img
              src="/F2_Clinical_Method.png"
              alt="Appraisal Image 2"
              className="max-h-full object-contain"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppraisalGrading;
